import { render, staticRenderFns } from "./TeamReviewSidebar.vue?vue&type=template&id=32949548&scoped=true"
import script from "./TeamReviewSidebar.vue?vue&type=script&lang=js"
export * from "./TeamReviewSidebar.vue?vue&type=script&lang=js"
import style0 from "./TeamReviewSidebar.vue?vue&type=style&index=0&id=32949548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32949548",
  null
  
)

export default component.exports